import { render, staticRenderFns } from "./sales-area-dialog.vue?vue&type=template&id=ed9e7a28&scoped=true"
import script from "./sales-area-dialog.vue?vue&type=script&lang=js"
export * from "./sales-area-dialog.vue?vue&type=script&lang=js"
import style0 from "./sales-area-dialog.vue?vue&type=style&index=0&id=ed9e7a28&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9e7a28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed9e7a28')) {
      api.createRecord('ed9e7a28', component.options)
    } else {
      api.reload('ed9e7a28', component.options)
    }
    module.hot.accept("./sales-area-dialog.vue?vue&type=template&id=ed9e7a28&scoped=true", function () {
      api.rerender('ed9e7a28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/compliancecso/salesman/dialog/sales-area-dialog.vue"
export default component.exports